export const DEFAULT_MIN_HOURS = 0;
export const DEFAULT_MAX_HOURS = 999;
